import { useEffect, useState } from "react";
import { useApi } from "./useApi";
import {priceResponce} from "../types/price";

/**
 * 旅行代金確認
 * 
 * @returns 
 */
export const useTravelPrice = (input: {data: any}) => {

  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<string|null>(null);
  const [priceData, setPriceData] = useState<priceResponce>();

  const fetchData = async () => {
    // データが不完全な場合はAPIを呼ばない（初回レンダリング対策）
    if (!input.data || !input.data.hotel || input.data.hotel.length === 0) {
      return;
    }

    setLoading(true);

    try {
      const response = await useApi.post({
        url: "/price",
        data: input.data
      });

      const priceData = response.data as priceResponce;

      if (priceData.status === 200) {
        setPriceData(priceData);
      } else {
        setError("料金の取得に失敗しました。");
      }

    } catch (error) {
      setError("APIの呼び出しに失敗しました。");
    }

    setLoading(false);
  }

  useEffect(() => {
    // input.dataが変更されたら再フェッチ
    // JSON.stringifyで内容の変更を検知
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(input.data)])

  const isError = error !== null;

  return [ priceData, { isLoading, isError, error } ] as const;
};